import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoriesPreview() {
  const displayCategories = categories.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            丰富的<strong className="text-primary-500">产品服务</strong>
          </h2>
          <p className="text-secondary-600 max-w-2xl mx-auto">
            涵盖体育竞技、真人视讯、电子游艺等六大品类，满足您的多元化娱乐需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.id}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-500 w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-sm text-secondary-600 leading-relaxed line-clamp-2">{cat.description}</p>
              <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                了解更多
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200"></i>
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-primary-500/40 text-primary-500 font-medium hover:bg-primary-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看全部品类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}